export const INFOS = {
    ATTENDANCE_RN: [
        'EM CASO DE ATENDIMENTO AO RECÉM-NATO, SELECIONE A OPÇÃO'
    ],
	KINSHIP_DEGREE: [
		'01 - CÔNJUGE (MARIDO OU ESPOSA).',
		'02 - COMPANHEIRO(A) (UNIÃO ESTÁVEL).',
		'03 - FILHO(A) (DESCENDENTE DIRETO).',
		'04 - ENTEADO(A) (FILHO(A) DO CÔNJUGE OU COMPANHEIRO).',
		'05 - PAI / MÃE (ASCENDENTE DIRETO)',
		'06 - PADRASTO / MADRASTA (CÔNJUGE OU COMPANHEIRO DOS PAIS).',
		'07 - AVÔ / AVÓ (ASCENDENTES 2º GRAU).',
		'08 - NETO(A) (DESCENDENTES 2º GRAU).',
		'09 - IRMÃO / IRMÃ (COLATERAIS 2º GRAU).',
		'10 - GENRO / NORA (CÔNJUGE DO FILHO OU FILHA).',
		'11 - OUTROS / TUTOR / GUARDA (RESPONSÁVEL LEGAL OU DEPENDENTE DIVERSO).'
	],
	ATTENDANCE_TYPE: [
		'01 - REMOÇÃO (TRANSPORTE EM AMBULÂNCIA).',
		'02 - PEQUENA CIRURGIA (CIRURGIA SIMPLES SEM INTERNAÇÃO).',
		'03 - OUTRAS TERAPIAS (SESSÕES DE FISIO, FONO OU PSICOLOGIA).',
		'04 - CONSULTA (ATENDIMENTO DE ROTINA NO CONSULTÓRIO).',
		'06 - ATENDIMENTO DOMICILIAR (CUIDADOS EM CASA - HOME CARE).',
		'07 - INTERNAÇÃO (PACIENTE ADMITIDO NO HOSPITAL).',
		'08 - QUIMIOTERAPIA (TRATAMENTO DO CÂNCER POR REMÉDIOS).',
		'09 - RADIOTERAPIA (TRATAMENTO DO CÂNCER POR RADIAÇÃO).',
		'10 - TERAPIA RENAL SUBSTITUTIVA (TRS) (SESSÕES DE HEMODIÁLISE).',
		'11 - PRONTO SOCORRO (ATENDIMENTO DE URGÊNCIA OU EMERGÊNCIA).',
		'13 - PEQUENO ATENDIMENTO (CUIDADOS RÁPIDOS COMO PONTOS OU GESSO).',
		'18 - SAÚDE OCUPACIONAL - MUDANÇA DE FUNÇÃO (EXAME DA EMPRESA POR TROCA DE CARGO).',
		'21 - SAÚDE OCUPACIONAL - ASSISTÊNCIA A DEMITIDOS (ATENDIMENTO APÓS DEMISSÃO).',
		'22 - TELESSAÚDE (CONSULTA ONLINE POR VÍDEO OU TELEFONE).',
		'23 - EXAME (REALIZAÇÃO DE PROCEDIMENTOS DIAGNÓSTICOS) .',
	],
	REGIME: [
		'01 - AMBULATORIAL (EXAMES OU TERAPIAS FEITOS NA CLÍNICA OU LABORATÓRIO).',
		'02 - DOMICILIAR (COLETA DE SANGUE OU FISIOTERAPIA FEITA NA CASA DO PACIENTE).',
		'03 - INTERNAÇÃO (EXAME REALIZADO DENTRO DO HOSPITAL EM PACIENTE INTERNADO).',
		'04 - PRONTO-SOCORRO (EXAME DE URGÊNCIA FEITO NA ESTRUTURA DO PRONTO-SOCORRO).',
		'05 - TELESSAÚDE (MONITORAMENTO OU LAUDO EXECUTADO DE FORMA REMOTA).',
	],
	OCCUPATIONAL_HEALTH: [
		'01 - ADMISSIONAL (EXAME MÉDICO OBRIGATÓRIO ANTES DE O FUNCIONÁRIO COMEÇAR A TRABALHAR).',
		'02 - DEMISSIONAL (EXAME MÉDICO COMPULSÓRIO REALIZADO NO DESLIGAMENTO DO EMPREGADO).',
		'03 - PERIÓDICO (AVALIAÇÃO DE ROTINA FEITA DE TEMPOS EM TEMPOS ENQUANTO O VÍNCULO EXISTE).',
		'04 - RETORNO AO TRABALHO (AVALIAÇÃO APÓS AFASTAMENTO POR DOENÇA, ACIDENTE OU PARTO).',
		'05 - MUDANÇA DE FUNÇÃO (EXAME EXIGIDO QUANDO O CARGO ALTERA OS RISCOS DA ATIVIDADE).',
		'06 - PROMOÇÃO À SAÚDE (AÇÕES PREVENTIVAS E CAMPANHAS DE BEM-ESTAR NO AMBIENTE CORPORATIVO).'
	],
	ACCIDENT_INDICATION: [
		'0 - ACIDENTE NO TRABALHO (EVENTOS OCORRIDOS NO EXERCÍCIO DA PROFISSÃO OU NO TRAJETO CASA-TRABALHO).',
		'1 - ACIDENTE NO TRÂNSITO (QUALQUER ACIDENTE ENVOLVENDO VEÍCULOS: CARROS, MOTOS, ATROPELAMENTOS, ETC.).',
		'2 - OUTROS ACIDENTES (QUEDAS DOMÉSTICAS, ACIDENTES DE LAZER OU EVENTOS SÚBITOS).',
		'9 - NÃO ACIDENTE (O MAIS COMUM. UTILIZADO PARA DOENÇAS ELETIVAS, ROTINA E CONSULTAS).'
	],
	CNS: [
		'CARTÃO NACIONAL DE SAÚDE (TAMBÉM CONHECIDO COMO CARTÃO DO SUS).'
	]
}
